import PRCategoryForm from '@app/components/apps/PRCategories/PRCategoryForm';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';

const routes = [
  {
    path: '/product-registrations-categories',
    breadcrumbName: 'Product Registrations Categories',
  },
  {
    path: '/add-product-registration-category',
    breadcrumbName: 'Add Product Registration Category',
  },
];

const CreatePRCategoryPage = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Product Registration Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <PRCategoryForm
        editable={true}
        pageTitle={'Create Product Registration Category'}
        type={'create'}
        setCurrentBreadcrumName={setCurrentBreadcrumName}
      />
    </Row>
  );
};

export default CreatePRCategoryPage;
